import { AuthService } from "@/services";
import initService from "@/services/modules/initService";
const Captcha = () => import("@/components/Captcha/index");

export default {
  name: "password-recovery",
  components: { Captcha },
  props: [],
  data() {
    return {
      emailOrMobile: "",
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      captchaStatus: false,
      rules: {
        required: value =>
          !!value ||
          this.$t("authPage.passwordRecoveryOTPPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    // recaptchaToken() {
    //   return this.$recaptchaInstance;
    // }
  },
  mounted() {
    this.getCaptchaStatus()
  },
  methods: {
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.users_password_recover
      })
    },
    onSubmit() {
      this.loading = true;
      this.recoverPassword();
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    recoverPassword() {
      AuthService.recoverPassword(
        this.emailOrMobile,
        this.captcha_token,
        this.captcha_value
      )
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          localStorage.setItem("emailOrMobile", this.emailOrMobile);
          localStorage.setItem("ttl", response.data.data.ttl);
          this.$router.push("password-recovery-otp");
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    }
  }
};
